import { render, staticRenderFns } from "./villageList.vue?vue&type=template&id=433e9d5b&scoped=true&"
import script from "./villageList.vue?vue&type=script&lang=js&"
export * from "./villageList.vue?vue&type=script&lang=js&"
import style0 from "./villageList.vue?vue&type=style&index=0&id=433e9d5b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433e9d5b",
  null
  
)

export default component.exports